import {themeConfig} from '@minimal/theme/theme-config';

import {CONFIG} from '../../global-config';
import type {SettingsState} from './types';

// ----------------------------------------------------------------------

export const defaultSettings: SettingsState = {
  colorScheme: themeConfig.defaultMode,
  direction: themeConfig.direction,
  contrast: 'default',
  navLayout: 'vertical',
  primaryColor: 'preset1',
  navColor: 'integrate',
  compactLayout: true,
  fontSize: 16,
  fontFamily: themeConfig.fontFamily.primary,
  version: CONFIG.appVersion,
};
